import * as React from 'react';
export function buildTemplates(config, resolvePath) {
    return config.supportedTemplates.reduce((map, template) => {
        return config.getSupportedSizesByTemplate(template).reduce((result, size) => {
            result[`${template}${size}`] = React.lazy(() => resolvePath(`${size}/${template}${size}`));
            return result;
        }, map);
    }, {});
}
//# sourceMappingURL=Config.js.map